import React from 'react'

import '@/components/Loading/LoadingV2.scss'

export default function Loading({ center = false }: { center?: boolean }) {
  const loading = (
    <div className="loadingio-spinner-ellipsis-a3q6v6jx7p7">
      <div className="ldio-wcqs1gr9e3r">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )

  return center ? (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      {loading}
    </div>
  ) : (
    loading
  )
}
